import { isProd, isStaging } from "./environment";
export const MANGO_HYDRATION = "MANGO_HYDRATION";
export const TEST_FF = "TEST_FF";
const createFeatureFlag = (dev, staging, prod) => ({ dev, staging, prod });
const featureFlags = {
    // [FEATURE_NAME]: createFeatureFlag(dev, staging, prod),
    [MANGO_HYDRATION]: createFeatureFlag(true, false, false),
    [TEST_FF]: createFeatureFlag(true, false, false),
};
const isEnabled = (feature) => {
    if (isProd)
        return featureFlags[feature].prod;
    if (isStaging)
        return featureFlags[feature].staging;
    else
        return featureFlags[feature].dev;
};
export default isEnabled;
